<section class="facility-empty d-flex">
    <img ngSrc="assets/{{ facilityName }}/img/empty.svg" alt="Empty facility" class="my-4" width="290" height="190" />
    <span class="mat-headline-6 mb-3 text-center foreground-primary-default">Looks like there is no information.</span>
</section>
